import React, { useEffect, useState } from "react";
import useAxios from "../Hooks/useAxios";
import { useNavigate } from "react-router-dom";
import styles from "./UserSettings.module.css";
import { HiEye, HiEyeOff } from "react-icons/hi";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import top_page from "../../assets/images/top_page.jpg";
import SingleChildInfo from "./SingleChildInfo";

import SingleAddressInfo from "./SingleAddressInfo";
import isValidPassword from "../utils/passwordValidator";
const UserSettings = () => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const axios = useAxios();
  const navigate = useNavigate();
  const initData = {
    Building_name: "",
    childrens: [],
    delivery_addresses: [],
    email: "",
    furigana_first_name: "",
    furigana_last_name: "",
    gender: null,
    id: -1,
    kanji_first_name: "",
    kanji_last_name: "",
    municipality: "",
    phone: "",
    post_code: "",
    prefecture: "",
    questions: null,
    register_date: "",
    user_code: null,
  };
  const initChild = {
    birthMonth: "",
    birthday: "",
    birthyear: "",
    furiganaName: "",
    kanjiname: "",
    sex: "女の子",
  };
  const initAddress = {
    postal_code: "",
    prefecture: "",
    municipality: "",
    Building_number: "",
    phone: "",
    kanji_first_name: "",
    kanji_last_name: "",
    furigana_first_name: "",
    furigana_last_name: "",
  };

  const [data, setData] = useState(initData);
  const [address1, setAddress1] = useState(null);
  const [address2, setAddress2] = useState(null);
  const [magazine, setMagazine] = useState(true);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleCurrentPasswordChange = (event) => {
    setCurrentPassword(event.target.value);
  };

  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };
  const confirmEdits = () => {
    if (currentPassword.length > 0) {
      if (newPassword.length > 0 && confirmPassword.length > 0) {
        if (newPassword !== confirmPassword) {
          alert("新しいパスワードが確認されたパスワードと一致しませんでした。");
          return;
        }
      } else {
        alert("フィールドを空にすることはできません。");
        return;
      }
    }

    if (!isValidPassword(newPassword)) {
      alert(
        "パスワードには、少なくとも 1 つの大文字と 1 つの小文字を含む 8 文字を含める必要があります。"
      );
      return;
    }

    let temp = JSON.parse(JSON.stringify(data));
    let postData = {
      main: {
        id: temp.id,
        kanji_first_name: temp.kanji_first_name,
        kanji_last_name: temp.kanji_last_name,
        furigana_first_name: temp.furigana_first_name,
        furigana_last_name: temp.furigana_last_name,
        email: temp.email,
        phone: temp.phone,
        post_code: temp.post_code,
        prefecture: temp.prefecture,
        municipality: temp.municipality,
        Building_name: temp.Building_name,
        magazine: magazine,
      },
      childrens: data.childrens,
      old_pass: currentPassword,
      new_pass: newPassword,
    };
    if (address1) {
      postData["address_1"] = address1;
    }
    if (address2) {
      postData["address_2"] = address2;
    }
    console.log(postData);
    axios
      .put(backend_base + "/user/details", {
        data: postData,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          alert(res.data?.msg);
          navigate("/edit-success");
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const handleChange = (e) => {
    let temp = JSON.parse(JSON.stringify(data));
    temp = { ...temp, [e.target.name]: e.target.value };
    setData(temp);
  };
  const handleChangeChildren = (e, index) => {
    let temp = JSON.parse(JSON.stringify(data));
    console.log("BEFORE AFTER:");
    console.log(temp);
    temp.childrens[index][e.target.name] = e.target.value;
    console.log(temp);
    setData(temp);
  };
  const addAnotherChild = () => {
    let temp = JSON.parse(JSON.stringify(data));
    temp.childrens.push(JSON.parse(JSON.stringify(initChild)));
    setData(temp);
  };
  useEffect(() => {
    axios
      .get(backend_base + "/user/userdetails")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting User Settings");
          console.log(res.data);
          setData(res.data);
          const addr = res.data.delivery_addresses;
          for (let i = 0; i < addr.length; i++) {
            if (addr[i].Address_type === 1) {
              setAddress1(addr[i]);
            }
            if (addr[i].Address_type === 2) {
              setAddress2(addr[i]);
            }
          }
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const fetchAddress = () => {
    let value = data.post_code;
    let zipsearch = value;
    if (value.length > 7) {
      zipsearch = value.replace(/[- ]/g, "");
    }
    zipsearch = parseInt(zipsearch);
    axios
      .post(backend_base + "/user/get/jp/address", {
        zipcode: zipsearch,
      })
      .then((response) => {
        if (response.status === 200) {
          //goto next page
          const result = response.data.address_data.results[0];
          console.log(result);
          setData({
            ...data,
            prefecture: result["address1"],
            municipality: result["address2"] + " " + result["address3"],
            post_code: value,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const changeAddress = (addressNo, newData) => {
    if (addressNo === 1) {
      setAddress1(newData);
      let temp = JSON.parse(JSON.stringify(data));
      temp.delivery_addresses.address1 = newData;
      setData(temp);
    } else {
      setAddress2(newData);
      let temp = JSON.parse(JSON.stringify(data));
      temp.delivery_addresses.address2 = newData;
      setData(temp);
    }
  };
  // useEffect(() => {
  //   axios
  //     .get(backend_base + "/shop/purchase/history")
  //     .then((res) => {
  //       if (res.status === 201 || res.status === 200) {
  //         console.log("Success History");
  //         console.log(res.data);
  //       } else {
  //         console.log("Failed");
  //       }
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // }, []);
  return (
    <>
      <Header />
      <div className={styles.main_div}>
        <div className={styles.top_crumb_main}>
          <div className={styles.tcm_text1}>TOPページ</div>
          <div className={styles.tcm_right_arrow}>&gt;</div>

          <div className={styles.tcm_text1}>マイページ</div>
          <div className={styles.tcm_right_arrow}>&gt;</div>

          <div className={styles.tcm_text1}>会員情報・配送先登録</div>
        </div>
        <div className={styles.header01}>
          <img src={top_page} className={styles.page_icon} alt="icon" />
          <div className={styles.text02}>設定・登録</div>
        </div>
        <div className={styles.main_info_box01}>
          <div className={styles.main_info_box01_title}>会員情報の変更</div>
          <div className={styles.main_info_box02_content_wrapper}>
            <div className={styles.mib01_col1_wrapper}>
              <div className={styles.mibc1_header}>
                会員登録情報（お届け先）
              </div>
              <div className={styles.hr01}></div>

              <div className={styles.info01_label01_col_wrapper}>
                <div className={styles.info01_row}>
                  <div className={styles.info01_item01}>お名前</div>
                  <div className={styles.info02_item02}>
                    <input
                      value={data.kanji_first_name}
                      onChange={handleChange}
                      name="kanji_first_name"
                      className={styles.input_sm01}
                    ></input>
                    <input
                      value={data.kanji_last_name}
                      onChange={handleChange}
                      name="kanji_last_name"
                      className={styles.input_sm01}
                    ></input>
                  </div>
                </div>
                <div className={styles.info01_row}>
                  <div className={styles.info01_item01}>ふりがな</div>
                  <div className={styles.info02_item02}>
                    <input
                      value={data.furigana_first_name}
                      onChange={handleChange}
                      name="furigana_first_name"
                      className={styles.input_sm01}
                    ></input>
                    <input
                      value={data.furigana_last_name}
                      onChange={handleChange}
                      name="furigana_last_name"
                      className={styles.input_sm01}
                    ></input>
                  </div>
                </div>
                <div className={styles.info01_row}>
                  <div className={styles.info01_item01}>携帯電話</div>
                  <div className={styles.info02_item02}>
                    <input
                      value={data.phone}
                      onChange={handleChange}
                      name="phone"
                      className={styles.input_sm01}
                    ></input>
                  </div>
                </div>
                <div className={styles.info01_row}>
                  <div className={styles.info01_item01}>郵便番号</div>
                  <div className={styles.info02_item02}>
                    <input
                      value={data.post_code}
                      onChange={handleChange}
                      name="post_code"
                      className={styles.input_sm01}
                    ></input>
                    <div onClick={fetchAddress} className={styles.under01}>
                      郵便番号検索
                    </div>
                  </div>
                </div>
                <div className={styles.info01_row}>
                  <div className={styles.info01_item01}>都道府県</div>
                  <div className={styles.info02_item02}>
                    <input
                      value={data.prefecture}
                      onChange={handleChange}
                      name="prefecture"
                      className={styles.input_sm01}
                    ></input>
                  </div>
                </div>
                <div className={styles.info01_row}>
                  <div className={styles.info01_item01}>市区町村以下</div>
                  <div className={styles.info02_item02}>
                    <input
                      value={data.municipality}
                      onChange={handleChange}
                      name="municipality"
                      className={styles.input_bg01}
                    ></input>
                  </div>
                </div>
                <div className={styles.info01_row}>
                  <div className={styles.info01_item01}>建物名</div>
                  <div className={styles.info02_item02}>
                    <input
                      value={data.Building_name}
                      onChange={handleChange}
                      name="Building_name"
                      className={styles.input_bg01}
                    ></input>
                  </div>
                </div>
                <div className={styles.info01_row}>
                  <div className={styles.info01_item01}>メールアドレス</div>
                  <div className={styles.info02_item02}>
                    <input
                      value={data.email}
                      onChange={handleChange}
                      name="email"
                      className={styles.input_bg01}
                    ></input>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.mib01_col2_wrapper}>
              <div className={styles.mibc1_header}>お子様の登録情報</div>
              <div className={styles.hr01}></div>
              {Array.isArray(data.childrens) &&
                data.childrens.length > 0 &&
                data.childrens.map((item, index) => {
                  return (
                    <div>
                      <SingleChildInfo
                        index={index}
                        handleChange={handleChangeChildren}
                        key={index}
                        data={item}
                      />
                    </div>
                  );
                })}
              <div onClick={addAnotherChild} className={styles.add_child_box}>
                ＋追加のお子様情報
              </div>
            </div>
          </div>
        </div>
        {!address1 && (
          <div className={styles.address_none_main_wrapper}>
            <div
              className={styles.address_none_main}
              onClick={() => {
                setAddress1({ ...initAddress });
              }}
            >
              ＋別送住所1　設定・登録
            </div>
          </div>
        )}
        {address1 && (
          <div className={styles.address_wrapper}>
            <SingleAddressInfo
              addressNo={1}
              changeAddress={changeAddress}
              data={address1}
            />
          </div>
        )}
        {!address2 && (
          <div className={styles.address_none_main_wrapper}>
            <div
              onClick={() => {
                setAddress2({ ...initAddress });
              }}
              className={styles.address_none_main}
            >
              ＋別送住所2　設定・登録
            </div>
          </div>
        )}
        {address2 && (
          <div className={styles.address_wrapper}>
            <SingleAddressInfo
              addressNo={2}
              changeAddress={changeAddress}
              data={address2}
            />
          </div>
        )}
        <ResetPasswordForm
          currentPassword={currentPassword}
          newPassword={newPassword}
          confirmPassword={confirmPassword}
          handleCurrentPasswordChange={handleCurrentPasswordChange}
          handleNewPasswordChange={handleNewPasswordChange}
          handleConfirmPasswordChange={handleConfirmPasswordChange}
        />
        <div className={styles.mail_magazine_main_box}>
          <div className={styles.mm_header01}>メルマガ登録の変更</div>
          <div className={styles.mm_main}>
            <div className={styles.mm_text01}>MyAceからのメールマガジン</div>
            <div className={styles.radio_section}>
              <input
                type="radio"
                name="mm"
                className={styles.radio}
                checked={magazine}
                onClick={() => {
                  setMagazine(true);
                }}
              />
              <div className={styles.radio_text1}>配信する</div>
              <input
                type="radio"
                name="mm"
                className={styles.radio}
                checked={!magazine}
                onClick={() => {
                  setMagazine(false);
                }}
              />
              <div className={styles.radio_text2}>停止する</div>
            </div>
            <div className={styles.mm_button}>設　定</div>
          </div>
        </div>
        <div onClick={confirmEdits} className={styles.button1}>
          登録内容を変更
        </div>
      </div>

      <Footer />
    </>
  );
};

const PasswordInput = ({
  label,
  value,
  enabled,
  placeholderTxt,
  showInfo,
  handlePasswordChange,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <div className={styles.password_input}>
      <label className={styles.password_label}>{label}</label>
      <div className={styles.password_input_field}>
        <input
          disabled={!enabled}
          type={isPasswordVisible ? "text" : "password"}
          value={value}
          onChange={handlePasswordChange}
          placeholder={`${placeholderTxt}`}
          autoComplete="new-password"
        />
        <span
          className={styles.password_visibility_toggle}
          onClick={togglePasswordVisibility}
        >
          {isPasswordVisible ? (
            <HiEye color="#bbb" />
          ) : (
            <HiEyeOff color="#bbb" />
          )}
        </span>
      </div>
      {showInfo && (
        <div className={`${styles.show_info} ml-3`}>
          <span>※半角英数混在8文字以上で設定してください</span>
        </div>
      )}
    </div>
  );
};

const ResetPasswordForm = ({
  currentPassword,
  newPassword,
  confirmPassword,
  handleCurrentPasswordChange,
  handleNewPasswordChange,
  handleConfirmPasswordChange,
}) => {
  return (
    <div className={styles.reset_pass_div_main_box}>
      <div className={styles.rp_header01}>パスワードの変更</div>
      <div className={styles.rp_main}>
        <PasswordInput
          label="現在のパスワード（必須)"
          enabled={true}
          value={currentPassword}
          placeholderTxt={"現在のパスワードを入力"}
          handlePasswordChange={handleCurrentPasswordChange}
        />
        <PasswordInput
          enabled={currentPassword.length > 0 ? true : false}
          label="新しいパスワード（必須）"
          value={newPassword}
          placeholderTxt={"新しいパスワードを入力"}
          showInfo={true}
          handlePasswordChange={handleNewPasswordChange}
        />
        <PasswordInput
          enabled={
            currentPassword.length > 0 && newPassword.length > 0 ? true : false
          }
          label="新しいパスワード（確認）"
          value={confirmPassword}
          placeholderTxt={"確認のため再入力してください"}
          handlePasswordChange={handleConfirmPasswordChange}
        />
      </div>
    </div>
  );
};

export default UserSettings;
